/* eslint-disable import/extensions */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../locale/en.json';
import ptTranslations from '../locale/pt.json';
import esTranslations from '../locale/es.json';

if (initReactI18next && typeof i18n.use === 'function') {
    i18n.use(initReactI18next);
}

if (typeof i18n.init === 'function') {
    i18n.init({
    resources: {
        en: {
            ...enTranslations,
        },
        pt: {
            ...ptTranslations,
        },
        es: {
            ...esTranslations,
        },
    },
    fallbackLng: {
        default: ['pt'],
    },
});
}

export default i18n;
